
  <form @submit.prevent="save">
    <b-loading :active="isLoading"></b-loading>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ currentPermanentPoint.id ? 'Edytowanie punktu stałego' : 'Dodawanie punktu stałego' }}</p>
        <button
            type="button"
            class="delete"
            aria-label="close"
            @click="$parent.$emit('close')"
        ></button>
      </header>
      <section class="modal-card-body">
        <div class="group">
          <div class="field field--client-name is-horizontal">
            <div class="field-label">Nazwa klienta:</div>
            <editable
                :isEditMode="true"
                :value="currentPermanentPoint.name"
                required
                placeholder="Imię Nazwisko / Nazwa firmy"
                type="text"
                @input="currentPermanentPoint.name = $event"
            />
          </div>
          <div class="field field--client-phone is-horizontal">
            <div class="field-label">Telefon:</div>
            <editable
                :isEditMode="true"
                :value="currentPermanentPoint.phone"
                required
                placeholder="600-123-123"
                type="text"
                @input="currentPermanentPoint.phone = $event"
            />
          </div>

          <div class="field is-horizontal">
            <div class="field-label">* Kraj:</div>
            <b-field class="field-body" grouped>
              <b-select
                  placeholder="Wybierz kraj"
                  v-model="currentPermanentPoint.country"
                  expanded
                  required
                  v-if="isEditModeEnabled"
              >
                <option value="PL">Polska</option>
                <option value="CZ">Czechy</option>
                <option value="SK">Słowacja</option>
                <option value="RO">Rumunia</option>
                <option value="HU">Węgry</option>
                <option value="DE">Niemcy</option>
                <option value="AT">Austria</option>
                <option value="HR">Chorwacja</option>
                <option value="SI">Słowenia</option>
              </b-select>
              <span
                  v-else
                  v-html="
											this.$options.filters.formatCountry(currentPermanentPoint.country) || 'nie wybrano'
										"
              ></span>
            </b-field>
          </div>
          <div class="field is-horizontal" v-if="isStateFieldEnabled">
            <div class="field-label">Województwo:</div>
            <b-field class="field-body" grouped v-if="currentPermanentPoint.country === 'PL'">
              <b-select
                  placeholder="Wybierz województwo"
                  v-model="currentPermanentPoint.state"
                  expanded
                  v-if="isEditModeEnabled"
              >
                <option value="dolnośląskie">dolnośląskie</option>
                <option value="kujawsko-pomorskie">kujawsko-pomorskie</option>
                <option value="lubelskie">lubelskie</option>
                <option value="lubuskie">lubuskie</option>
                <option value="łódzkie">łódzkie</option>
                <option value="małopolskie">małopolskie</option>
                <option value="mazowieckie">mazowieckie</option>
                <option value="opolskie">opolskie</option>
                <option value="podkarpackie">podkarpackie</option>
                <option value="podlaskie">podlaskie</option>
                <option value="pomorskie">pomorskie</option>
                <option value="śląskie">śląskie</option>
                <option value="świętokrzyskie">świętokrzyskie</option>
                <option value="warmińsko-mazurskie">warmińsko-mazurskie</option>
                <option value="wielkopolskie">wielkopolskie</option>
                <option value="zachodniopomorskie">zachodniopomorskie</option>
              </b-select>
              <span
                  v-else
                  v-html="
											this.$options.filters.formatCountry(currentPermanentPoint.state) || 'nie wybrano'
										"
              ></span>
            </b-field>
            <b-field class="field-body" grouped v-else-if="currentPermanentPoint.country === 'HR'">
              <b-select
                  placeholder="Wybierz żupanję"
                  v-model="currentPermanentPoint.state"
                  expanded
                  v-if="isEditModeEnabled"
              >
                <option value="zagrebačka">zagrebačka</option>
                <option value="krapinsko-zagorska">krapinsko-zagorska</option>
                <option value="sisačko-moslavačka">sisačko-moslavačka</option>
                <option value="karlovačka">karlovačka</option>
                <option value="varaždinska">varaždinska</option>
                <option value="koprivničko-križevačka">koprivničko-križevačka</option>
                <option value="bjelovarsko-bilogorska">bjelovarsko-bilogorska</option>
                <option value="primorsko-goranska">primorsko-goranska</option>
                <option value="ličko-senjska">ličko-senjska</option>
                <option value="virovitičko-podravska">virovitičko-podravska</option>
                <option value="požeško-slavonska">požeško-slavonska</option>
                <option value="brodsko-posavska">brodsko-posavska</option>
                <option value="zadarska">zadarska</option>
                <option value="osječko-baranjska">osječko-baranjska</option>
                <option value="šibensko-kninska">šibensko-kninska</option>
                <option value="vukovarsko-srijemska">vukovarsko-srijemska</option>
                <option value="splitsko-dalmatinska">splitsko-dalmatinska</option>
                <option value="istarska">istarska</option>
                <option value="dubrovačko-neretvanska">dubrovačko-neretvanska</option>
                <option value="međimurska">međimurska</option>
                <option value="grad zagreb">grad zagreb</option>
              </b-select>
              <span
                  v-else
                  v-html="
											this.$options.filters.formatCountry(currentPermanentPoint.state) || 'nie wybrano'
										"
              ></span>
            </b-field>
            <editable
                v-else
                :isEditMode="true"
                :value="currentPermanentPoint.state"
                placeholder="Województwo"
                type="text"
                @input="currentPermanentPoint.state = $event"
            />
          </div>
          <div class="field is-horizontal">
            <div class="field-label">Miasto:</div>
            <editable
                :isEditMode="true"
                :value="currentPermanentPoint.city"
                placeholder="Kraków"
                type="text"
                @input="currentPermanentPoint.city = $event"
            />
          </div>
          <div class="field is-horizontal">
            <div class="field-label">Ulica:</div>
            <editable
                :isEditMode="true"
                :value="currentPermanentPoint.street"
                placeholder="Szeroka 123"
                type="text"
                @input="currentPermanentPoint.street = $event"
            />
          </div>
          <div class="field is-horizontal">
            <div class="field-label">* Kod pocztowy:</div>
            <editable
                :isEditMode="true"
                :value="currentPermanentPoint.postalCode"
                required
                placeholder="00-000"
                type="text"
                @input="currentPermanentPoint.postalCode = $event"
            />
          </div>
          <div class="field is-horizontal">
            <div class="field-label">* Poczta:</div>
            <editable
                :isEditMode="true"
                :value="currentPermanentPoint.post"
                required
                placeholder="Poczta"
                type="text"
                @input="currentPermanentPoint.post = $event"
            />
          </div>
          <div class="field is-horizontal">
            <div class="field-label">Lokalizacja:</div>
            <div class="field field-body">
              <button
                  type="button"
                  class="button is-info is-outlined"
                  :disabled="false"
                  @click.prevent="findLocation"
                  v-if="!isLocationFormVisible && !currentPermanentPoint.lat && !currentPermanentPoint.lon"
              >
                <i class="mdi">gps_fixed</i>
                Znajdź
              </button>
              <b-dropdown
                  v-if="currentPermanentPoint.lat && currentPermanentPoint.lon && !isLocationFormVisible"
                  :disabled="!canEdit"
              >
                <button class="button is-info" slot="trigger" @click.prevent type="button">
											<span>
												GPS
												<small
                        >({{ currentPermanentPoint.lat | toFixed(3) }},
													{{ currentPermanentPoint.lon | toFixed(3) }})</small
                        >
											</span>
                  <i class="mdi">arrow_drop_down</i>
                </button>
                <b-dropdown-item @click="findLocation">
                  <i class="mdi">edit</i> Zmień
                </b-dropdown-item>
                <b-dropdown-item class="is-danger" @click="clearLocation">
                  <i class="mdi">cancel</i> Wyczyść
                </b-dropdown-item>
              </b-dropdown>
              <div class="field is-expanded" v-if="isLocationFormVisible">
                <b-field grouped>
                  <b-select
                      v-model="currentPermanentPoint.selectedLocation"
                      :placeholder="
													areLocationsLoading ? 'wczytywanie lokalizacji...' : 'Wybierz lokalizację'
												"
                      expanded
                      :loading="areLocationsLoading"
                      :disabled="areLocationsLoading"
                      @input="selectedLocation = $event"

                  >
                    <option
                        v-for="(location, index) in locations"
                        :key="index"
                        :value="{ lat: location.lat, lon: location.lon }"
                    >
                      {{ location.display_name }}
                      {{ location.isBestMatch ? ' [Najlepszy wynik]' : '' }}
                    </option>
                  </b-select>
                </b-field>
                <b-field grouped class="action-buttons">
                  <button
                      type="button"
                      class="button"
                      @click.prevent="isLocationFormVisible = false"
                      :disabled="areLocationsLoading"
                  >
                    <i class="mdi">cancel</i>
                    <span>Anuluj</span>
                  </button>
                </b-field>
              </div>
            </div>
          </div>

        </div>
      </section>
      <footer class="modal-card-foot">
        <button type="submit" class="button is-success button--add">
          <i class="mdi">save</i> Zapisz
        </button>
        <button
            class="button is-white button--cancel"
            type="button"
            @click="$parent.$emit('close')"
        >
          Anuluj
        </button>
      </footer>
    </div>
  </form>
